import { useEffect, useState } from "react";
import { getLocation } from "../../../services/Location";
import EmailValidatedToCheckExistComponent from "../../../components/EmailValidatedToCheckExistComponent";
import { DoesEmailExist } from "../../../services/Users";
import { PleasewaitPopup } from "../../../components/PleasewaitPopup";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseURL } from "../../../config/api";
import useAuth from "../../../hook/useAuth";
import { formatUSPhone, getUSPhoneDigits } from "../../../utils/phoneFormatter";
import { validateMin } from "../../../utils/validateMin";
import { getStatus } from "../../../services/Appointment";

export const AddVendor = () => {
    const navigate = useNavigate();
    const { auth }: any = useAuth();
    const [locationOptions, setLocationOptions] = useState<any[]>([]);
    const [locationId, setLocationId] = useState<number>(0);
    const [statusOptions, setStatusOptions] = useState<any[]>([]);
    const [statusId, setStatusId] = useState<number>(0);
    const [vendorName, setVendorName] = useState<string>("");
    const [address1, setAddress1] = useState<string>("");
    const [address2, setAddress2] = useState<string>("");
    const [city, setCity] = useState<string>("");
    const [state, setState] = useState<string>("");
    const [zipCode, setZipCode] = useState<string>("");
    const [phone, setPhone] = useState<string>("");
    const [isPhoneValid, setIsPhoneValid] = useState<boolean>(false);
    const [fax, setFax] = useState<string>("");
    const [vendorTaxID, setVendorTaxID] = useState<string>("");
    const [vendorTerms, setVendorTerms] = useState<string>("");
    const [county, setCounty] = useState<string>("");
    const [country, setCountry] = useState<string>("");
    const [commission, setCommission] = useState<number>(0);
    const [rent, setRent] = useState<number>(0);
    const [contactPerson1, setContactPerson1] = useState<string>("");
    const [contactPerson1Phone, setContactPerson1Phone] = useState<string>("");
    const [isContact1PhoneValid, setIsContact1PhoneValid] = useState<boolean>(false);
    const [contactPerson2, setContactPerson2] = useState<string>("");
    const [contactPerson2Phone, setContactPerson2Phone] = useState<string>("");
    const [isContact2PhoneValid, setIsContact2PhoneValid] = useState<boolean>(false);
    const [website, setWebsite] = useState<string>("");
    const [minimumOrder, setMinimumOrder] = useState<number>(0);
    const [defaultOrderingMode, setDefaultOrderingMode] = useState<string>("");
    const [defaultBillableDepartment, setDefaultBillableDepartment] = useState<string>("");
    const [defaultPODelivery, setDefaultPODelivery] = useState<string>("");
    const [deliveryTime, setDeliveryTime] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [emailTouched, setEmailTouched] = useState<boolean>(false);
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);


    useEffect(() => {
        getLocation()
            .then((data) => {
                setLocationOptions(() => data?.map((loc: any) => {
                    return {
                        value: loc?.id,
                        label: loc?.locationName
                    }
                }))

                setLocationId(data[0]?.id);
            })
            .catch((error) => {
                console.error(error)
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        getStatus("Vendor")
            .then((data) => {
                setStatusOptions(() => data?.map((status: any) => {
                    return {
                        value: status?.statusID,
                        label: status?.statusValue
                    }
                }))

                setStatusId(data[0]?.statusID);
            })
            .catch((error) => {
                console.error(error)
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        let timer: NodeJS.Timeout;

        if (phone.trim() !== "") {
            timer = setTimeout(() => {
                const valid = /^\d{10}$/.test(phone);
                setIsPhoneValid(valid);
            }, 500);
        } else {
            setIsPhoneValid(true);
        }

        return () => clearTimeout(timer);
    }, [phone]);

    useEffect(() => {
        let timer: NodeJS.Timeout;

        if (contactPerson1Phone.trim() !== "") {
            timer = setTimeout(() => {
                const valid = /^\d{10}$/.test(contactPerson1Phone);
                setIsContact1PhoneValid(valid);
            }, 500);
        } else {
            setIsContact1PhoneValid(true);
        }

        return () => clearTimeout(timer);
    }, [contactPerson1Phone]);


    useEffect(() => {
        let timer: NodeJS.Timeout;

        if (contactPerson2Phone.trim() !== "") {
            timer = setTimeout(() => {
                const valid = /^\d{10}$/.test(contactPerson2Phone);
                setIsContact2PhoneValid(valid);
            }, 500);
        } else {
            setIsContact2PhoneValid(true);
        }

        return () => clearTimeout(timer);
    }, [contactPerson2Phone]);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setPleaseWaitPopup(true);

        await axios
            .post(
                `${baseURL}vendors?userId=${auth?.id}`,
                JSON.stringify({
                    locationId,
                    vendorName,
                    statusId,
                    address1,
                    address2,
                    city,
                    state,
                    zipCode,
                    phone,
                    fax,
                    vendorTaxID,
                    vendorTerms,
                    county,
                    country,
                    email,
                    commission,
                    rent,
                    contactPerson1,
                    contactPerson1Phone,
                    contactPerson2,
                    contactPerson2Phone,
                    website,
                    deliveryTime,
                    minimumOrder,
                    defaultOrderingMode,
                    defaultBillableDepartment,
                    defaultPODelivery,
                    createdAt: new Date().toLocaleString(),
                    createdBy: auth?.givenname,
                }),
                {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: false,
                }
            )
            .then((response) => {
                setPleaseWaitPopup(false);
                navigate(-1);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
                console.error("Error:", error);
            });
    }

    return (
        <>
            <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
                <div className="w-full bg-white p-4 rounded-md">
                    <h2 className={`text-lg font-semibold`}>Add Vendor</h2>

                    <div className="mt-2 p-2">
                        <form onSubmit={(e) => handleSubmit(e)}>
                            <div className="w-full">
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-6">
                                    {/* First Column */}
                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Vendor Name<span className="text-red-500">*</span></label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={vendorName}
                                                placeholder="Vendor Name"
                                                onChange={(e) => setVendorName(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <EmailValidatedToCheckExistComponent
                                            email={email}
                                            setEmail={setEmail}
                                            getEmail={DoesEmailExist}
                                            touched={emailTouched}
                                            setTouched={setEmailTouched}
                                            className={{
                                                parentDiv: "",
                                                label: "block text-xs font-medium text-secondary",
                                                input:
                                                    "w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent",
                                            }}
                                        />

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Status<span className="text-red-500">*</span></label>
                                            <select
                                                value={statusId}
                                                onChange={(e) => setStatusId(Number(e.target.value))}
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                            >

                                                {statusOptions.map((status: any, index: number) => (
                                                    <option key={index} value={status?.value}>
                                                        {status?.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Location<span className="text-red-500">*</span></label>
                                            <select
                                                value={locationId}
                                                onChange={(e) => setLocationId(Number(e.target.value))}
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                            >

                                                {locationOptions.map((loc: any, index: number) => (
                                                    <option key={index} value={loc?.value}>
                                                        {loc?.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Address2</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={address2}
                                                placeholder="Address2"
                                                onChange={(e) => setAddress2(e.target.value)}

                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">State<span className="text-red-500">*</span></label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={state}
                                                placeholder="State"
                                                onChange={(e) => setState(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Country<span className="text-red-500">*</span></label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={country}
                                                placeholder="Country"
                                                onChange={(e) => setCountry(e.target.value)}
                                                required
                                            />
                                        </div>


                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Tax ID</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={vendorTaxID}
                                                placeholder="Tax ID"
                                                onChange={(e) => setVendorTaxID(e.target.value)}

                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Commission</label>
                                            <input
                                                type="number"
                                                min={0}
                                                step={0.01}
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={commission}
                                                placeholder="Commission"
                                                onChange={(e) => setCommission(validateMin(e.target.value, 0))}

                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Contact Person 1</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={contactPerson1}
                                                placeholder="Contact Person 1"
                                                onChange={(e) => setContactPerson1(e.target.value)}

                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Contact Person 2</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={contactPerson2}
                                                placeholder="Contact Person 2"
                                                onChange={(e) => setContactPerson2(e.target.value)}

                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Website</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={website}
                                                placeholder="Website"
                                                onChange={(e) => setWebsite(e.target.value)}

                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Default Ordering Mode</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={defaultOrderingMode}
                                                placeholder="Default Ordering Mode"
                                                onChange={(e) => setDefaultOrderingMode(e.target.value)}

                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Default PO Delivery</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={defaultPODelivery}
                                                placeholder="Default PO Delivery"
                                                onChange={(e) => setDefaultPODelivery(e.target.value)}

                                            />
                                        </div>

                                    </div>

                                    {/* Second Column */}
                                    <div className="space-y-4">

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Phone Number<span className="text-red-500">*</span></label>
                                            <input
                                                type="text"
                                                placeholder="Phone Number"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                required
                                                value={formatUSPhone(phone)}
                                                pattern="[\(][0-9]{3}[\)][\s]{1}[0-9]{3}[\-]{1}[0-9]{4}"
                                                title="Please Enter a 10 digits numbers."
                                                onChange={(e) => {
                                                    const digits = getUSPhoneDigits(e.target.value);
                                                    setPhone(digits);
                                                }}
                                            />
                                            {!isPhoneValid && (
                                                <div className="flex items-center gap-1 mt-2 text-xs text-red-500 ml-1">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 26 26"
                                                        strokeWidth={2}
                                                        stroke="currentColor"
                                                        className="w-4 h-4 text-red-500"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            d="M12 9v3m0 3h.01m-9 0a9 9 0 1118 0 9 9 0 01-18 0z"
                                                        />
                                                    </svg>

                                                    <span>Please enter a valid 10-digit phone number</span>
                                                </div>
                                            )}
                                        </div>


                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Fax</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={fax}
                                                placeholder="Fax"
                                                onChange={(e) => setFax(e.target.value)}

                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Address1<span className="text-red-500">*</span></label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={address1}
                                                placeholder="Address1"
                                                onChange={(e) => setAddress1(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">City<span className="text-red-500">*</span></label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={city}
                                                placeholder="City"
                                                onChange={(e) => setCity(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">County</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={county}
                                                placeholder="County"
                                                onChange={(e) => setCounty(e.target.value)}

                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Zip Code<span className="text-red-500">*</span></label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={zipCode}
                                                placeholder="Zip Code"
                                                onChange={(e) => setZipCode(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Vendor Terms</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={vendorTerms}
                                                placeholder="Vendor Terms"
                                                onChange={(e) => setVendorTerms(e.target.value)}

                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Rent</label>
                                            <input
                                                type="number"
                                                min={0}
                                                step={0.01}
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={rent}
                                                placeholder="Rent"
                                                onChange={(e) => setRent(validateMin(e.target.value, 0))}

                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Contact Person 1 Phone</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={formatUSPhone(contactPerson1Phone)}
                                                placeholder="Contact Person 1 Phone"
                                                pattern="[\(][0-9]{3}[\)][\s]{1}[0-9]{3}[\-]{1}[0-9]{4}"
                                                title="Please Enter a 10 digits numbers."
                                                onChange={(e) => {
                                                    const digits = getUSPhoneDigits(e.target.value);
                                                    setContactPerson1Phone(digits);
                                                }}

                                            />
                                            {!isContact1PhoneValid && (
                                                <div className="flex items-center gap-1 mt-2 text-xs text-red-500 ml-1">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 26 26"
                                                        strokeWidth={2}
                                                        stroke="currentColor"
                                                        className="w-4 h-4 text-red-500"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            d="M12 9v3m0 3h.01m-9 0a9 9 0 1118 0 9 9 0 01-18 0z"
                                                        />
                                                    </svg>

                                                    <span>Please enter a valid 10-digit phone number</span>
                                                </div>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Contact Person 2 Phone</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={formatUSPhone(contactPerson2Phone)}
                                                placeholder="Contact Person 2 Phone"
                                                pattern="[\(][0-9]{3}[\)][\s]{1}[0-9]{3}[\-]{1}[0-9]{4}"
                                                title="Please Enter a 10 digits numbers."
                                                onChange={(e) => {
                                                    const digits = getUSPhoneDigits(e.target.value);
                                                    setContactPerson2Phone(digits);
                                                }}

                                            />
                                            {!isContact2PhoneValid && (
                                                <div className="flex items-center gap-1 mt-2 text-xs text-red-500 ml-1">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 26 26"
                                                        strokeWidth={2}
                                                        stroke="currentColor"
                                                        className="w-4 h-4 text-red-500"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            d="M12 9v3m0 3h.01m-9 0a9 9 0 1118 0 9 9 0 01-18 0z"
                                                        />
                                                    </svg>

                                                    <span>Please enter a valid 10-digit phone number</span>
                                                </div>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Minimum Order</label>
                                            <input
                                                type="number"
                                                min={0}
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={minimumOrder}
                                                placeholder="Minimum Order"
                                                onChange={(e) => setMinimumOrder(validateMin(e.target.value, 0))}

                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Default Billable Department</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={defaultBillableDepartment}
                                                placeholder="Default Billable Department"
                                                onChange={(e) => setDefaultBillableDepartment(e.target.value)}

                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Delivery Time</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={deliveryTime}
                                                placeholder="Delivery Time"
                                                onChange={(e) => setDeliveryTime(e.target.value)}

                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Buttons */}
                                <div className="flex flex-col sm:flex-row gap-4 mt-6">
                                    <button
                                        type="submit"
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                    >
                                        Save
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => navigate(-1)}
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-[#FFFFFF] text-primary cursor-pointer border border-primary"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <PleasewaitPopup showPopup={pleaseWaitPopup} />
        </>
    )
}